import React, { useState, useEffect } from "react";
import {
  Button,
  ErrorMessage,
  Input,
  UpgradeCard,
  Success,
} from "../../../components";
import { connect, useSelector } from "react-redux";

import { CountriesList, toAbsoluteUrl } from "../../../services";
import Select from "react-dropdown-select";
import { useFormik } from "formik";

import { sendSupportQuery } from "../../../redux/actions/free/homeActions";
import "./index.css"

import * as Yup from "yup";
const data = (state) => state.premiumHome;
const QueryForm = (props) => {
  const [file, setFile] = useState("");
  const [country, setCountry] = useState([]);
  const [errState, setErrorState] = useState(false);
  const [filename, setFileName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [upgrade, setUpgrade] = useState(false);
  const [show, setShowSuccess] = useState(false);

  
  let allData = useSelector(data);

  let updatePlan = () => {
    setUpgrade(!upgrade);
  };

  let onCloseUpgrade = () => {
    setUpgrade(!upgrade);
  };
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      number: "",
      details: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required!"),
      email: Yup.string()
        .email("Invalid email address!")
        .required("Email is required!"),
      number: Yup.string().required("Number is required!"),
      details: Yup.string().required("Details are required!"),
    }),
    onSubmit: (values) => {
      let data = {
        name: values.name,
        email: values.email,
        details: values.details,
        number: values.number,
        country,
      };
      console.log(country);
      if (country?.length < 1) {
        setErrorState(true);
      } else {
        props.sendSupportQuery(data);
        setTimeout(() => {
          setErrorMessage("");
          setCountry([]);
          formik.resetForm();
        }, 2000);
      }
    },
  });

  let handleFile = (e) => {
    let files = e.target.files; // Access the array of selected files
    let filePromises = []; // Array to store promises for reading files

    for (let i = 0; i < files.length; i++) {
      let file = files[i];
      if (/\.(jpe?g|png)$/i.test(file.name)) {
        if (filePromises.length < 20) { // Restrict to 20 images
          // Create a promise for reading each valid file
          let promise = new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.addEventListener("load", () => {
              resolve({ name: file.name, result: reader.result }); // Resolve the promise with the file name and result
            });
            reader.readAsDataURL(file);
          });
          filePromises.push(promise); // Add the promise to the array
        } else {
          setError(true);
          setErrorMessage("You can only upload a maximum of 20 images.");
        }
      } else {
        setError(true);
        setErrorMessage(`Invalid file format: ${file.name}`);
      }
    }

    Promise.all(filePromises)
      .then((results) => {
        let fileNames = results.map((file) => file.name);
        let fileResults = results.map((file) => file.result);
        setFileName(fileNames);
        setFile(fileResults);
      })
      .catch(() => {
        setError(true);
        setErrorMessage("Error occurred while uploading files.");
      });
  };



  useEffect(() => {
    if (allData && allData?.supportMessage) {
      setShowSuccess(true);
    }
  }, [allData]);

  return (
    <div className="queryForm" >
      <form
        onSubmit={formik.handleSubmit}
        className="bg-[#efede0] w-[45rem] mx-auto px-10 py-5 rounded"
      >
        <div className="head text-center">
          <h1 className=" text-[#007E8C] text-4xl font-bold">
            Connect with us
          </h1>
          <div className="description mt-4 font-thin">
            <p className="text-[#3B4345] text-[1rem] font-medium">
              Please fill the form below to get in touch with our team
            </p>
          </div>
        </div>
        <div className="personalInfo flex justify-center mt-5">
          <div className="left mr-5 w-full">
            <div className="name">
              <Input
                {...formik.getFieldProps("name")}
                placeholder="Full Name * "
                value={formik.values.name}
                customStyle="border-1  border-[#DDDDDD]"
              />
              {formik.touched.name && formik.errors.name && (
                <div>
                  <span className="text-red-600 text-base font-semibold">
                    {formik.errors.name}
                  </span>
                </div>
              )}
            </div>
            <div className="country mt-4">
              <Select
                placeholder="Your Country *"
                values={country}
                options={CountriesList}
                onChange={(values) => {
                  setCountry(values);
                  setErrorState(false);
                }}
                isSearchable="false" // searchable for the closest one
                style={{
                  fontWeight: "500",
                  borderWidth: "1px",
                  paddingLeft: "10px",
                  fontSize: "16px",
                  borderColor: "#DDDDDD",
                  backgroundColor: "white",
                  borderRadius: 5,
                  height: "44px",
                  width: "100%"
                }}
              />
              {errState ? (
                <div className="text-red-600 text-base font-semibold">
                  Country is required
                </div>
              ) : null}
              {formik.touched.country && formik.errors.country && (
                <div>
                  <span className="text-red-600 text-base font-semibold">
                    {formik.errors.country}
                  </span>
                </div>
              )}
            </div>
          </div>
          <div className="right w-full">
            <div className="email">
              <Input
                {...formik.getFieldProps("email")}
                value={formik.values.email}
                placeholder="Work Email * "
                customStyle="border-1  border-[#DDDDDD]"
              />
              {formik.touched.email && formik.errors.email && (
                <div>
                  <span className="text-red-600 text-base font-semibold">
                    {formik.errors.email}
                  </span>
                </div>
              )}
            </div>
            <div className="phone mt-[-10px]">
              <Input
                {...formik.getFieldProps("number")}
                type="number"
                placeholder="Phone Number *"
                customStyle="border-1  border-[#DDDDDD]"
                value={formik.values.number}
              />
              {formik.touched.number && formik.errors.number && (
                <div>
                  <span className="text-red-600 text-base font-semibold">
                    {formik.errors.number}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="mt-4">
          <textarea
            id="comment"
            {...formik.getFieldProps("details")}
            value={formik.values.details}
            rows="6"
            className="w-full px-3 py-2 text-[15px] rounded-md text-[#292929] focus:outline-none focus:bg-white  bg-white border-1 border-[#DDDDDD] "
            placeholder="Type your message here..."
          ></textarea>
          {formik.touched.details && formik.errors.details && (
            <div>
              <span className="text-red-600 text-base font-semibold">
                {formik.errors.details}
              </span>
            </div>
          )}
        </div>

        {/* <div className="flex items-center justify-center w-full mt-4">
          <label
            htmlFor="dropzone-file"
            className="flex flex-col items-center justify-center w-full border-1 border-[#DDDDDD] rounded-md cursor-pointer bg-white"
          >
            <div class="flex flex-col items-center justify-center pt-6 pb-6">
              <img src={toAbsoluteUrl("/media/dashboard/uploadfile.png")} />

              {filename ? (
                <p class="mb-2 ml-4 text-sm text-[#007E8C]">
                  {filename.map((r, i) => {
                    return <span className="px-2" key={i}>
                      {r}
                    </span>
                  })}</p>
              ) : (
                <div className="text-center">
                  <p className="mb-2 text-sm font-semibold text-[#007E8C]">
                    Click or drag files to this area to upload.
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">
                    You can upload up to 20 files.
                  </p>
                </div>
              )}
            </div>
            <input
              id="dropzone-file"
              type="file"
              multiple
              onChange={handleFile}
              className="hidden"
            />
          </label>
        </div> */}
        {error ? (
          <div className="w-max mx-auto my-6">
            <ErrorMessage onClick={() => setError(false)} text={errorMessage} />
          </div>
        ) : null}
        <div className="submitBtn mt-2 text-center">
          {allData && allData.errorMessage ? (
            <div>
              <span className="text-red-600 my-2 text-sm font-semibold">
                {allData.errorMessage}
              </span>
            </div>
          ) : null}

          <Button
            name={allData?.supportLoading ? "Please Wait.." : "Send Query"}
            customStyle="px-10 py-2 mt-2"
            type="submit"
          />
        </div>
      </form>

      {show ? (
        <Success
          onclick={() => setShowSuccess(false)}
          text="Your message has been delivered successfully! Someone from our team will reach out to you soon."
        />
      ) : null}

      {upgrade ? (
        <UpgradeCard type="FREE" onCloseUpgrade={onCloseUpgrade} />
      ) : null}



      {
        props.screen === "login" ?
          null :
          <div className="my-10 flex justify-between">
            <div></div>
            <div className="text-center">
              <h1 className="font-medium text-xl  text-[#3B4345]">
                Your Current Plan:{" "}
                <b className="font-bold text-xl text-[#007E8C]">FREE</b>
              </h1>
              <button
                onClick={() => updatePlan()}
                className="font-medium underline text-[#007E8C] mt-2"
              >
                Upgrade Your Plan
              </button>
            </div>
            <div></div>
          </div>

      }


    </div>
  );
};

const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, { sendSupportQuery })(QueryForm);
